import s from '../allservices.jsx'
import { getClientId, getClientSecret,buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';
export const verifyCardService = (actionCallback) => {
//     let token = "Token " + localStorage.getItem('token')
let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
        if(localStorage.getItem('cardNumber')=== null){
            return;
        }
          const state = {
          cardNumber: localStorage.getItem('cardNumber'),
          applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
           }
        let gvvid = getClientId();
         let traceId = getClientId();
    fetch(plink + s.verify_card,{
        method: "POST",
        headers: {
            'content-type': 'application/json',
            'clientId': gvvid,
            'clientSecret': getClientSecret(gvvid, localStorage.getItem('cdNo')),
             'X-Trace-Id': traceId,
             'X-KlickEx-Client':buildClientHeader(),
          //   'Authorization': token
        },
        body: JSON.stringify(state)
 

    })
//     
    .then(response => {
          if (response.status === 200) {
              response.json().then(json => actionCallback(json, "success"))
          }
          else if (response.status === 401) {
              let data = "signout."
              actionCallback(data, "Failure")
          }
          else {
              let data = "No Data."
              actionCallback(data, "emptyBody")
          }
          
      })
  }


// WEBPACK FOOTER //
// ./src/services/components/verify_card.jsx